import { render, staticRenderFns } from "./ListiniTariffeEdit.vue?vue&type=template&id=3417aac4&"
import script from "./ListiniTariffeEdit.vue?vue&type=script&lang=ts&"
export * from "./ListiniTariffeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports